/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Button, Col, Form, Input, Modal, Row, Skeleton, Table, Tooltip, Typography } from 'antd';
import {
  MoreOutlined,
  RightCircleOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  DeleteOutlined,
  SettingOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Button as CrcButton, Spinner } from '@crc-evans/ui-components';
import {
  deleteAdminEquipTypes,
  fetchAdminEquipTypes,
  fetchAdminPihEquipTypes,
} from '../../redux/admin/equipmentTypes/action';
import EquipmentsNo from './EquipmentsNo';
import {
  fetchAdminEquipSno,
  fetchAdminEquipTypeSno,
  fetchAdminEquipSubTypeSno,
  fetchAdminEquipDocType,
} from '../../redux/admin/equipmentSno/action';
import EquipSubCategory from './EquipSubCategory';
import DocumentList from './DocumentList';
import CommonAGGridTable from '../AG Grid/CommonAGGridTable';

const { Text } = Typography;

const DocEquipmentTypes = (props) => {
  const {
    openPage,
    setOpenPage,
    setOpenModel,
    openModal,
    checkOpen,
    setChecksOpen,
    equipTypeList,
    setEquipTypeList,
    categoryDataList,
    categoryData,
    adminEquipTypesLoading,
    equipmentType,
    setEquipmentType,
    equipTypeForm,
    editModelValue,
    setEditModelValue,
    setEditRecord,
    editRecord,
    OnclearEquipType,

    onDeleteEquipType,
    isEquipTypeDeleteLoading,
    adminEquipTypeSnoData,
    adminEquipTypeSnoLoad,
    onGetEquipSno,
    equipTypeSearchForm,
    clear,
    setClear,
    adminEquipTypesTotalCount,
    onGetPihEquipmentTypes,
    paginationClear,
    setPaginationClear,
    onFetchAdminEquipSubType,
    onFetchAdminEquipDocType,
    equipmentFormData,
    //
    setDocumentId,
    documentId,
    equipmentSubTypeId,
    setEquipmentSubTypeId,
    handleSetForm,
    setSubCategoryPageActive,
    setDocumentPageActive,
    searchCriteria,
    setSearchCriteria,
    onOpenAddDocumentModal,
  } = props;

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteEquipId, setDeleteEquipId] = useState('');
  const [equipmentTypeId, setEquipmentTypeId] = useState();
  const [equipmentTypeName, setEquipmentTypeName] = useState();
  const [equipmentSubTypeName, setEquipmentSubTypeName] = useState();
  const [openSubEquip, setOpenSubEquip] = useState('');
  const [closeDocList, setCloseDocList] = useState('');
  const [prevClickCount, setPrevClickCount] = useState(0);

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [subTypeTableList, setSubTypeTableList] = useState([]);
  const [subTypeName, setSubTypeName] = useState('');

  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(10000);

  const [adminEquipTypeSnoDataList, setAminEquipTypeSnoDataList] = useState([]);

  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);

  const [equipmentTypeSearch, setEquipmentTypeSearch] = useState('');
  /** false = A→Z, true = Z→A; toggled by clicking the EQUIPMENT TYPE header label */
  const [equipmentTypeSortDesc, setEquipmentTypeSortDesc] = useState(false);

  const equipmentTypeWatched = Form.useWatch('equipmentType', equipTypeSearchForm);
  const pihEquipmentWatched = Form.useWatch('pihEquipment', equipmentFormData);
  const pihCategoryWatched = Form.useWatch('pihCategory', equipmentFormData);
  const displayEquipmentTitle = useMemo(() => {
    const fromState = equipmentTypeName && String(equipmentTypeName).trim();
    if (fromState) return fromState;
    const fromSearch = equipmentTypeWatched && String(equipmentTypeWatched).trim();
    if (fromSearch) return fromSearch;
    const fromPih = pihEquipmentWatched && String(pihEquipmentWatched).trim();
    if (fromPih) return fromPih;
    const fromCategory = pihCategoryWatched && String(pihCategoryWatched).trim();
    if (fromCategory) return fromCategory;
    return '';
  }, [equipmentTypeName, equipmentTypeWatched, pihEquipmentWatched, pihCategoryWatched]);

  const toggleEquipmentTypeSort = useCallback(() => {
    setEquipmentTypeSortDesc((d) => !d);
  }, []);

  const tableDataSource = useMemo(() => {
    let list = [...(equipTypeList || [])];
    const term = equipmentTypeSearch.trim().toLowerCase();
    if (term) {
      list = list.filter((item) => (item.pihEquipmentType || '').toLowerCase().includes(term));
    }
    list.sort((a, b) => {
      const cmp = (a.pihEquipmentType || '').localeCompare(b.pihEquipmentType || '', undefined, {
        sensitivity: 'base',
      });
      return equipmentTypeSortDesc ? -cmp : cmp;
    });
    return list;
  }, [equipTypeList, equipmentTypeSearch, equipmentTypeSortDesc]);

  const docTableColumns = useMemo(
    () => [
      {
        title: <span className="equipment-type-column-title">S.NO</span>,
        dataIndex: 'ID',
        key: 'ID',
        align: 'center',
        width: 80,
        render: (text, record, index) => index + 1,
      },
      {
        title: () => (
          <div className="equipment-type-header-with-search">
            <span
              className="equipment-type-column-title equipment-type-column-title-sortable"
              onClick={(e) => {
                e.stopPropagation();
                toggleEquipmentTypeSort();
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  toggleEquipmentTypeSort();
                }
              }}
              role="button"
              tabIndex={0}
            >
              EQUIPMENT TYPE
              {equipmentTypeSortDesc ? (
                <CaretDownOutlined className="equipment-type-sort-dir-icon" aria-hidden />
              ) : (
                <CaretUpOutlined className="equipment-type-sort-dir-icon" aria-hidden />
              )}
            </span>
            <Input
              placeholder="Search..."
              value={equipmentTypeSearch}
              onChange={(e) => setEquipmentTypeSearch(e.target.value)}
              allowClear
              className="equipment-type-search-input"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        ),
        dataIndex: 'pihEquipmentType',
        key: 'pihEquipmentType',
        align: 'left',
        ellipsis: true,
        render: (text) => <span className="equipment-types-name">{text}</span>,
      },
      {
        title: <span className="equipment-type-column-title">ACTIONS</span>,
        key: 'editDelete',
        width: 150,
        align: 'center',
        render: (text, record) => (
          <div className="heat-profile-actions-cell">
            <Tooltip title="View manuals & diagrams" placement="top">
              <RightCircleOutlined
                className="txtIcon"
                onClick={async () => {
                  setChecksOpen(true);
                  setOpenPage('');
                  equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
                  setEquipmentTypeName(record.pihEquipmentType);
                  setEquipmentSubTypeName(record.pihEquipmentType);
                  setEquipmentSubTypeId(record.id);
                  equipmentFormData.setFieldsValue({ pihCategory: record.pihEquipmentType });
                }}
              />
            </Tooltip>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps -- form instances and parent setters are stable for column actions
    [equipmentTypeSearch, equipmentTypeSortDesc, toggleEquipmentTypeSort]
  );

  useEffect(() => {
    (async () => {
      var obj = {
        pageSize: currentPagesize,
        pageNumber: searchCriteria != '' ? 1 : currentPageNumber,
        searchKey: searchCriteria,
      };

      await onGetPihEquipmentTypes(obj);
    })();
  }, [searchCriteria]);

  useEffect(() => {
    if (adminEquipTypeSnoData) setAminEquipTypeSnoDataList(adminEquipTypeSnoData);
  }, [adminEquipTypeSnoData]);

  useEffect(() => {
    if (categoryData && categoryData.length > 0) {
      // Filter out items with empty/null/undefined/whitespace-only equipment types
      let filteredData = categoryData.filter((item) => {
        const type = item.pihEquipmentType;
        return type && type.trim() !== '';
      });

      // Remove duplicates based on pihEquipmentType (case-insensitive)
      const seen = new Set();
      const uniqueData = filteredData.filter((item) => {
        const key = item.pihEquipmentType.trim().toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      // Sort alphabetically (case-insensitive)
      uniqueData.sort((a, b) =>
        a.pihEquipmentType
          .trim()
          .toLowerCase()
          .localeCompare(b.pihEquipmentType.trim().toLowerCase())
      );

      setSubTypeTableList(uniqueData);
    }
  }, [categoryData]);

  const RemoveDuplicates = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  };
  const typesListColumns = [
    {
      title: 'Equipment Types',
      dataIndex: 'pihEquipmentType',
      key: 'pihEquipmentType',
      align: 'left',
      // sorter: (a, b) => {return (a-b)},
      ellipsis: true,
    },
    {
      title: () => {
        return <MoreOutlined style={{ fontSize: '18px' }} />;
      },
      key: 'action',
      dataIndex: 'action',
      align: 'center',
      width: '100px',
      render: (text, record) => {
        return (
          <div className="tableIcons">
            <Tooltip
              title="View manuals & diagrams"
              placement="top"
            >
              <RightCircleOutlined
                className="icon-22"
                onClick={async () => {
                  setChecksOpen(true);
                  setOpenPage('');
                  equipTypeSearchForm.setFieldsValue({ equipmentType: record.pihEquipmentType });
                  setEquipmentTypeName(record.pihEquipmentType);

                  setEquipmentSubTypeName(record.pihEquipmentType);
                  setEquipmentSubTypeId(record.id);
                  equipmentFormData.setFieldsValue({ pihCategory: record.pihEquipmentType });
                  // setEquipmentTypeId(record.id);
                  // console.log(record)
                  // equipmentFormData.setFieldsValue({ pihEquipment: record.pihEquipmentType });
                  //await onFetchAdminEquipSubType({ pihEquipmentTypeCategory: record.equipmentTypeCategory });
                }}
              />
            </Tooltip>
          </div>
        );
      },
      align: 'center',
    },
  ];

  /** Setting values for updating equipment types */
  const setEditModel = (record) => {
    setOpenModel(true);
    setEditRecord(record);
    setEditModelValue(true);
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setDeleteModal(false);
    setDeleteEquipId('');
  };

  /** Waiting to delete equipment type and close Modal */
  useEffect(() => {
    if (!isEquipTypeDeleteLoading) {
      setDeleteModal(false);
      setDeleteEquipId('');
      // OnclearEquipType();
      setClear(false);
      equipTypeSearchForm.resetFields();
      setPaginationClear(false);
    }
  }, [isEquipTypeDeleteLoading]);

  return (
    <div>
      {!checkOpen && openPage != 'documentList' ? (
        <div className="heat-profile-table-wrap">
          <Table
            columns={docTableColumns}
            dataSource={tableDataSource}
            rowKey={(record) => record.id || record.sno}
            className="h-100 pipeline-table equipPaginationTable heat-profile-table equipment-types-table"
            loading={{
              spinning: equipTypeList.length === 0 || adminEquipTypesLoading,
              indicator: <Spinner variant="inline" size="large" color="#00C9A7" />,
            }}
            pagination={
              equipTypeList.length > 10
                ? {
                  position: ['bottomRight'],
                  showSizeChanger: true,
                  className: 'heat-profile-pagination',
                  defaultPageSize: 10,
                }
                : false
            }
          />
        </div>
      ) : (
        <div>
          <div className="admin-doc-equipment-heading" style={{ marginBottom: 16 }}>
            <a
              href="#back"
              onClick={(e) => {
                e.preventDefault();
                setChecksOpen(false);
                setOpenPage('');
                if (!clear) {
                  equipTypeSearchForm.resetFields();
                  OnclearEquipType();
                  setAminEquipTypeSnoDataList([]);
                  setEquipmentTypeName('');
                }
              }}
              className="heat-profile-page-back-link"
            >
              <div className="heat-profile-back-link">
                <ArrowLeftOutlined /> Back
              </div>
            </a>
            <div className="admin-doc-equipment-title-block">
              <h2 className="admin-doc-equipment-title heat-profile-list-title">
                {displayEquipmentTitle || 'Documentation'}
              </h2>
              {equipmentSubTypeName &&
                String(equipmentSubTypeName).trim() &&
                String(equipmentSubTypeName).trim() !== displayEquipmentTitle && (
                <p className="admin-doc-equipment-subtitle heat-profile-list-description" style={{ margin: '4px 0 0' }}>
                  {equipmentSubTypeName}
                </p>
              )}
            </div>
          </div>

          <div className="heat-profile-card" style={{ marginTop: 0, padding: '24px 0 0 0' }}>
            <DocumentList
              equipmentTypeId={equipmentTypeId}
              equipmentSubTypeId={equipmentSubTypeId}
              documentId={documentId}
              setDocumentId={setDocumentId}
              equipmentSubTypeName={equipmentSubTypeName}
              equipmentTypeName={displayEquipmentTitle}
              handleSetForm={handleSetForm}
              onOpenAddDocumentModal={onOpenAddDocumentModal}
            />
          </div>
        </div>
      )}
      <Modal
        width="45vw"
        className="materials-modal-modern heatprofile-modal pipeline-modal"
        title="Delete Equipment Type"
        centered
        visible={deleteModal}
        onCancel={handleCancel}
        footer={[
          <CrcButton
            key="cancel"
            label="Cancel"
            onClick={handleCancel}
            variant="tertiary"
            size="medium"
          />,
          <CrcButton
            key="apply"
            label={isEquipTypeDeleteLoading ? 'Deleting' : 'Confirm'}
            onClick={() => onDeleteEquipType({ pihEquipmentType: deleteEquipId.pihEquipmentType })}
            disabled={isEquipTypeDeleteLoading}
            variant="primary"
            size="medium"
          />,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            <p>
              Deleting Equipment Type will delete all the corresponding Equipments and related
              information.
            </p>
            Are you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>{deleteEquipId && deleteEquipId.pihEquipmentType}</b>{' '}
            Equipment Type?
          </Text>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ adminEquipTypeReducer, adminEquipSnoReducer }) => {
  const adminEquipTypes = get(adminEquipTypeReducer, 'adminEquipTypes', []);
  const adminEquipTypesTotalCount = get(adminEquipTypeReducer, 'adminEquipTypesTotalCount', null);
  const adminEquipTypesLoading = get(adminEquipTypeReducer, 'adminEquipTypesLoading', false);
  const isEquipTypeDeleteLoading = get(adminEquipTypeReducer, 'isEquipTypeDeleteLoading', false);
  const adminEquipTypeSnoLoad = get(adminEquipSnoReducer, 'adminEquipTypeSnoLoad', false);
  const adminEquipTypeSnoData = get(adminEquipSnoReducer, 'adminEquipTypeSnoData', []);
  return {
    adminEquipTypes,
    adminEquipTypesLoading,
    isEquipTypeDeleteLoading,
    adminEquipTypeSnoData,
    adminEquipTypeSnoLoad,
    adminEquipTypesTotalCount,
  };
};

const mapDispatchToProps = {
  onDeleteEquipType: deleteAdminEquipTypes,
  onGetEquipSno: fetchAdminEquipTypeSno,
  onGetPihEquipmentTypes: fetchAdminPihEquipTypes,
  onFetchAdminEquipSubType: fetchAdminEquipSubTypeSno,
  onFetchAdminEquipDocType: fetchAdminEquipDocType,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocEquipmentTypes);
